import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import Button from "@material-ui/core/Button";
import CloudDownload from "@material-ui/icons/CloudDownload";

const styles = theme => ({
  para: {
    fontSize: 16
  },
  button: {
    margin: theme.spacing.unit,
    fontSize: 16
  },
  leftIcon: {
    marginRight: theme.spacing.unit
  },
  rightIcon: {
    marginLeft: theme.spacing.unit
  },
  imgdiv: {
    textAlign: "center",
    margin: "10px"
  },
  img: {
    borderRadius: "8px",
    border: "1px solid gray",
    width: "80%"
  }
});

const srm20 = props => {
  const { classes } = props;
  return (
    <div>
      <Typography variant="h5">Additive Manufacturing Technology</Typography>
      <Typography className={classes.para} paragraph>
        Additive Manufacturing is defined as the process of joining materials to
        make objects from 3D model data, usually layer upon layer, as opposed to
        subtractive manufacturing methodologies.
      </Typography>
      {/* <Typography variant="h6">Subtractive vs Additive </Typography>
      <Typography variant="h6">Advantages</Typography>
      <Typography variant="h6">Limitations</Typography> */}
      <Typography variant="h5">3D Printer - Fracktal Works Julia </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./dprint/dddprinter.jpg"
          alt="3dscan"
        />
      </div>
      <Typography variant="h6">3D Printer Test</Typography>
      <Link href={"https://www.thingiverse.com/thing:1363023"}>
        {" "}
        3D printer Test v3{" "}
      </Link>{" "}
      file by
      <Link href={"https://www.thingiverse.com/ctrlV"}> ctrlV </Link>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./dprint/group/test_desc.jpg"
          alt="3dscan"
        />
      </div>
      <Typography className={classes.para} paragraph>
        In fast mode of printer the overhang of angle 25 and 30 degree failed
        but in normal mode it went fine.
      </Typography>
      {/* This file includes 20 tests.
      <ul>
        <li>Overhang</li>
        <li />
      </ul> */}
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./dprint/group/test.jpg"
          alt="3dscan"
        />
      </div>
      <Typography className={classes.para} paragraph>
        Then a hole test was done at normal setting of printer to find what is
        the smallest size that can be made with printer. 0.5 mm hole was not
        there at all.
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./dprint/group/holetest.jpg"
          alt="3dscan"
        />
      </div>
      The infill can seen as follows at different printer settings.
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./dprint/group/influx.jpg"
          alt="3dscan"
        />
      </div>
      <Typography variant="h5">Assignment - A Faucet Aerator</Typography>
      <Typography className={classes.para} paragraph>
        Faucet Aerator (or tap aerator) is used for creating a non-splashing
        stream and often delivering a mixture of water and air. I wanted to make
        this for two reasons. Firstly, I wanted to save water usage at Vigyan
        Ashram kitchen while not making the flow non-splashing as all the
        students here wash the dishes they use after having food. <br />{" "}
        Secondly, I wanted to know how to create a stream-bubble or foam flow
        using faucet aerator. I started by opening a faucet aerator and tried to
        reverse engineer it.
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./dprint/faucet_or.jpg"
          alt="3dscan"
        />
      </div>
      <Typography className={classes.para} paragraph>
        I found that the hole dimensions are too small to print using this
        printer. So I made some compromise. I'm still iterating the design to
        make the bubble-stream flow. However, it does save water with no visible
        change in pressure.
      </Typography>
      <div className={classes.imgdiv}>
        <img className={classes.img} src="./dprint/3d_parts.jpg" alt="3dscan" />
      </div>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./dprint/3d_assembled.jpg"
          alt="3dscan"
        />
      </div>
      <Typography className={classes.para} paragraph>
        {" "}
        I failed to make the foam flow.{" "}
      </Typography>
      <div className={classes.imgdiv}>
        <img className={classes.img} src="./dprint/in_use.jpg" alt="3dscan" />
      </div>
      <Typography className={classes.para} paragraph>
        This cannot be made subtractively. As a general rule if the coordinates
        of the tool movement if represented by the projection of the 3D object
        overlap the tool cant reach the overhangs.
      </Typography>
      <div className={classes.imgdiv}>
        <img className={classes.img} src="./dprint/cad.png" alt="3dscan" />
      </div>
      <div className={classes.imgdiv}>
        <img className={classes.img} src="./dprint/cad2.png" alt="3dscan" />
      </div>
      <Button
        target="_blank"
        href={"./dprint/Assem1.zip"}
        variant="contained"
        size="small"
        color="primary"
        className={classes.button}
      >
        <CloudDownload className={classes.leftIcon} />
        Download file
      </Button>
    </div>
  );
};

export default withStyles(styles)(srm20);
